module.exports = __webpack_public_path__ + "img/emoticon-nps-3-on.78dd0d6c.svg";